import { forwardRef, type ComponentPropsWithoutRef, type ReactNode, type Ref } from "react";
import classnames from "classnames";

import Styles from "./index.module.scss";

export function MenuWrapper({
  children,
  className,
  isOpen,
  transparentHeader,
  automationId,
}: {
  children: ReactNode;
  className?: string;
  isOpen: boolean;
  transparentHeader?: boolean;
  automationId?: string;
}) {
  return (
    <div
      data-automation-id={automationId || "popout-menu"}
      className={classnames(
        Styles.popoutMenu,
        className,
        isOpen && Styles.isOpen,
        transparentHeader && Styles.transparentHeader,
      )}
    >
      {children}
    </div>
  );
}

type MenuItemWrapperProps = {
  children?: ReactNode;
  removeInteractionState?: boolean;
} & ComponentPropsWithoutRef<"li">;

export function MenuItemWrapper({
  children,
  removeInteractionState,
  ...props
}: MenuItemWrapperProps) {
  return (
    <li
      className={classnames(
        Styles.popoutMenuListItemContainer,
        removeInteractionState && Styles.removeInteractionState,
      )}
      {...props}
    >
      {children}
    </li>
  );
}

type MenuListProps = {
  alignTop?: boolean;
  alignBottom?: boolean;
  alignLeft?: boolean;
  alignCenter?: boolean;
  children: ReactNode;
  menuClassName?: string;
  header?: ReactNode;
} & ComponentPropsWithoutRef<"div">;

function MenuList(
  {
    menuClassName,
    alignTop,
    alignBottom,
    alignLeft,
    alignCenter,
    children,
    header,
    ...props
  }: MenuListProps,
  ref: Ref<HTMLDivElement>,
) {
  return (
    <div
      {...props}
      ref={ref}
      className={classnames(
        Styles.popoutMenuList,
        alignTop && Styles.alignTop,
        alignBottom && Styles.alignBottom,
        alignLeft && Styles.alignLeft,
        alignCenter && Styles.alignCenter,
        menuClassName,
      )}
    >
      {header}
      <ul>{children}</ul>
    </div>
  );
}

const MenuListWithRef = forwardRef(MenuList);

export { MenuListWithRef as MenuList };
